import _ from 'underscore';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
import { Button } from '@fluentui/react-components';
import {
  Drawer,
  DrawerHeader,
  DrawerHeaderTitle,
  DrawerBody,
  DrawerFooter
} from '@fluentui/react-drawer';
import {
  MessageBar, MessageBarBody, MessageBarTitle,
} from '@fluentui/react-message-bar';
import { Dismiss24Regular } from '@fluentui/react-icons';
import { GoalPropType } from '@bingads-webui-campaign-react/auto-goal-creation-wizard-utils';
import { I18nContext } from '@bingads-webui-react/i18n-context';

import { GoalDetailForm } from './goal-details-setting-form';

export const GoalDetailSettingDrawer = ({
  accountName,
  activity,
  goal,
  isOpen,
  isReadOnly,
  message,
  setGoal,
  setIsOpen,
  restoreFocusSourceAttributes,
}) => {
  const i18n = useContext(I18nContext);
  const [draftGoal, setDraftGoal] = useState(_.clone(goal));
  const [isFormValid, setIsFormValid] = useState(true);

  useEffect(() => {
    setDraftGoal(_.clone(goal));
  }, [goal]);

  const onSaveBtnClick = () => {
    if (isFormValid) {
      setGoal(draftGoal);
      if (activity && activity.trace) {
        activity.trace(`[GoalDetailForm] onSaveBtnClick draftGoal  ${JSON.stringify(draftGoal)}`);
      }
    }
  };

  const onCancelBtnClick = () => {
    setDraftGoal(_.clone(goal));
    if (activity && activity.trace) {
      activity.trace(`[GoalDetailForm] onCancelBtnClick draftGoal  ${JSON.stringify(draftGoal)}`);
    }
    setIsOpen(false);
  };

  return (
    <Drawer
      {...restoreFocusSourceAttributes}
      className="goal-detail-edit-form"
      open={isOpen}
      onOpenChange={(ev, { open }) => setIsOpen(open)}
      position="end"
      size="medium"
      modalType="modal"

    >
      <DrawerHeader>
        <DrawerHeaderTitle
          action={
            <Button
              className="goal-detail-edit-close"
              appearance="subtle"
              aria-label="Close"
              icon={<Dismiss24Regular />}
              onClick={() => setIsOpen(false)}
            />
            }
        >
          {i18n.getString(_TL_('Edit settings'))}
        </DrawerHeaderTitle>
      </DrawerHeader>
      <DrawerBody>
        <GoalDetailForm
          draftGoal={draftGoal}
          setDraftGoal={setDraftGoal}
          isFormValid={isFormValid}
          setIsFormValid={setIsFormValid}
          accountName={accountName}
          activity={activity}
        />
      </DrawerBody>
      {message &&
        <DrawerFooter>
          <MessageBar shape="rounded" intent="error">
            <MessageBarBody>
              <MessageBarTitle>{message}</MessageBarTitle>
            </MessageBarBody>
          </MessageBar>
        </DrawerFooter>
      }
      <DrawerFooter>
        <Button
          className="goal-detail-save-btn"
          appearance="primary"
          onClick={onSaveBtnClick}
          disabled={!isFormValid || isReadOnly}
        >
          {i18n.getString(_TL_('Save'))}
        </Button>
        <Button
          className="goal-detail-cancel-btn"
          onClick={onCancelBtnClick}
        >
          {i18n.getString(_TL_('Cancel'))}
        </Button>
      </DrawerFooter>
    </Drawer>
  );
};

GoalDetailSettingDrawer.propTypes = {
  accountName: PropTypes.string.isRequired,
  activity: PropTypes.shape({
    trace: PropTypes.func.isRequired,
    error: PropTypes.func.isRequired,
  }),
  goal: PropTypes.shape(GoalPropType).isRequired,
  isOpen: PropTypes.bool.isRequired,
  isReadOnly: PropTypes.bool,
  message: PropTypes.string,
  setGoal: PropTypes.func.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  restoreFocusSourceAttributes: PropTypes.shape({}),
};

GoalDetailSettingDrawer.defaultProps = {
  activity: {
    trace: _.noop,
    error: _.noop,
  },
  isReadOnly: false,
  message: null,
  restoreFocusSourceAttributes: {},
};
